import { Component, AfterViewInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from '../../material/material.module';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-dialog-privacy-policy',
    standalone: true,
    imports: [MaterialModule, CommonModule],
    template: `
    <div class="dialog-container">
      <mat-dialog-content class="dialog-content">
        <div class="privacy-header">
          <div class="header-content">
            <div class="logo-section">
              <img src="/assets/Hubmedical_logo_PNG.png" alt="HubMedical" class="logo" width="120" height="36">
            </div>
            <div class="version-info">
              <p class="version">Versão 1.0</p>
              <p class="publish-date">Publicado em Dezembro 2025</p>
            </div>
          </div>
        </div>
        

        <div class="company-info">
          <h2 class="company-title">Termo de Consentimento para Tratamento de Dados Pessoais e Sensíveis</h2>
          <div class="company-data">
            <p><strong>Razão Social:</strong> INNÉ INTELIGÊNCIA EM NEGÓCIOS LTDA. ME</p>
            <p><strong>Nome Fantasia:</strong> HubMedical</p>
            <p><strong>CNPJ:</strong> 27.390.450/0001-94</p>
            <p><strong>Endereço:</strong> Rua Corticeira da Serra, nº 71 - CEP 88.056-368, Florianópolis/SC</p>
            <p><strong>Contato do Encarregado de Dados (DPO):</strong> 
               <a href="mailto:planos@elosaude.com.br" class="email-link">planos&#64;elosaude.com.br</a>
            </p>
          </div>
        </div>

        <!-- Table of Contents -->
        <nav class="toc" role="navigation" aria-label="Índice da política de privacidade">
          <h2 class="toc-title">Índice</h2>
          <ol class="toc-list">
            <li><a href="#finalidade" (click)="scrollToSection('finalidade', $event)">Finalidade do Tratamento de Dados</a></li>
            <li><a href="#tipos-dados" (click)="scrollToSection('tipos-dados', $event)">Tipos de Dados Coletados</a></li>
            <li><a href="#base-legal" (click)="scrollToSection('base-legal', $event)">Base Legal</a></li>
            <li><a href="#compartilhamento" (click)="scrollToSection('compartilhamento', $event)">Compartilhamento de Dados</a></li>
            <li><a href="#seguranca" (click)="scrollToSection('seguranca', $event)">Segurança da Informação</a></li>
            <li><a href="#retencao" (click)="scrollToSection('retencao', $event)">Retenção e Eliminação</a></li>
            <li><a href="#direitos" (click)="scrollToSection('direitos', $event)">Direitos do Titular</a></li>
            <li><a href="#confidencialidade" (click)="scrollToSection('confidencialidade', $event)">Confidencialidade</a></li>
            <li><a href="#responsabilidades" (click)="scrollToSection('responsabilidades', $event)">Responsabilidades e Isenções</a></li>
            <li><a href="#atualizacoes" (click)="scrollToSection('atualizacoes', $event)">Atualizações deste Termo</a></li>
          </ol>
        </nav>

        <div class="privacy-content">
          <div class="title-section">
            <h1 class="main-title">Política de Privacidade – HubMedical</h1>
            <div class="download-section">
              <button mat-raised-button 
                      color="primary" 
                      class="download-btn"
                      (click)="downloadPDF()"
                      aria-label="Baixar PDF da política de privacidade">
                <mat-icon>download</mat-icon>
                Baixar PDF
              </button>
            </div>
          </div>
          
          <!-- Section 1 -->
          <section id="finalidade" class="privacy-section">
            <h2>1. Finalidade do Tratamento de Dados</h2>
            <p>Ao utilizar a plataforma HubMedical, o usuário consente com a coleta, armazenamento, uso e compartilhamento de seus dados pessoais e sensíveis, com as seguintes finalidades:</p>
            <ul>
              <li>Validação de identidade e certificações profissionais ou institucionais</li>
              <li>Gestão documental e controle de validade de documentos</li>
              <li>Criação e gerenciamento de ofertas e demandas de serviços na área da saúde</li>
              <li>Compartilhamento seguro de documentos entre perfis autorizados</li>
              <li>Comunicação institucional e notificações sobre vencimento de documentos</li>
              <li>Cumprimento de obrigações legais e regulatórias</li>
            </ul>
          </section>

          <!-- Section 2 -->
          <section id="tipos-dados" class="privacy-section">
            <h2>2. Tipos de Dados Coletados</h2>
            <p>A plataforma poderá coletar e tratar os seguintes dados:</p>
            
            <div class="data-category">
              <h3>Dados Pessoais</h3>
              <p>Nome, CPF, RG, endereço, e-mail, telefone</p>
            </div>

            <div class="data-category">
              <h3>Dados Profissionais</h3>
              <p>Número de registro em conselho regional, certificados de especialização, vínculo com CNES</p>
            </div>

            <div class="data-category">
              <h3>Dados Institucionais</h3>
              <p>CNPJ, documentos de cadastro no CNES, licenças e autorizações</p>
            </div>

            <div class="data-category">
              <h3>Dados Sensíveis</h3>
              <p>Informações sobre formação profissional, documentos de saúde, dados de identificação biométrica (se aplicável)</p>
            </div>
          </section>

          <!-- Section 3 -->
          <section id="base-legal" class="privacy-section">
            <h2>3. Base Legal</h2>
            <p>O tratamento dos dados é realizado com fundamento nas seguintes bases legais:</p>
            <ul>
              <li>Consentimento do titular</li>
              <li>Cumprimento de obrigação legal ou regulatória</li>
              <li>Execução de contrato ou procedimentos preliminares</li>
              <li>Legítimo interesse da plataforma, respeitando os direitos do titular</li>
            </ul>
          </section>

          <!-- Section 4 -->
          <section id="compartilhamento" class="privacy-section">
            <h2>4. Compartilhamento de Dados</h2>
            <p>Os dados poderão ser compartilhados apenas:</p>
            <ul>
              <li>Entre usuários da plataforma, mediante consentimento específico</li>
              <li>Com órgãos reguladores e fiscalizadores, quando exigido por lei</li>
              <li>Com prestadores de serviços que auxiliam no funcionamento da plataforma</li>
            </ul>
          </section>

          <!-- Section 5 -->
          <section id="seguranca" class="privacy-section">
            <h2>5. Segurança da Informação</h2>
            <p>A HubMedical adota medidas técnicas e administrativas para proteger os dados contra acessos não autorizados, perdas, alterações ou divulgações indevidas, incluindo:</p>
            <ul>
              <li><strong>Criptografia:</strong> Dados em trânsito e em repouso</li>
              <li><strong>Controle de acesso:</strong> Por perfis de usuário</li>
              <li><strong>Monitoramento:</strong> Contínuo e auditorias periódicas</li>
              <li><strong>Resposta a incidentes:</strong> Em até 48 horas</li>
            </ul>
          </section>

          <!-- Section 6 -->
          <section id="retencao" class="privacy-section">
            <h2>6. Retenção e Eliminação</h2>
            <p>Os dados serão mantidos pelo tempo necessário para cumprir as finalidades descritas ou conforme exigência legal. Após esse período, serão eliminados ou anonimizados.</p>
          </section>

          <!-- Section 7 -->
          <section id="direitos" class="privacy-section">
            <h2>7. Direitos do Titular</h2>
            <p>O titular dos dados poderá, a qualquer momento, solicitar:</p>
            <ul>
              <li>Confirmação da existência de tratamento</li>
              <li>Acesso aos dados</li>
              <li>Correção de dados incompletos, inexatos ou desatualizados</li>
              <li>Anonimização, bloqueio ou eliminação de dados desnecessários</li>
              <li>Portabilidade dos dados</li>
              <li>Revogação do consentimento</li>
            </ul>
            <div class="contact-info">
              <p><strong>Como exercer seus direitos:</strong></p>
              <p>As solicitações devem ser feitas ao Encarregado de Dados (DPO) pelo e-mail: 
                 <a href="mailto:planos@elosaude.com.br" class="email-link">planos&#64;elosaude.com.br</a>
              </p>
            </div>
          </section>

          <!-- Section 8 -->
          <section id="confidencialidade" class="privacy-section">
            <h2>8. Confidencialidade</h2>
            <p>As obrigações de sigilo e não divulgação permanecem válidas mesmo após o encerramento da relação contratual com a plataforma.</p>
          </section>

          <!-- Section 9 -->
          <section id="responsabilidades" class="privacy-section">
            <h2>9. Responsabilidades e Isenções</h2>
            <p>A HubMedical se compromete com a verificação documental e a segurança dos dados, mas se isenta de responsabilidades por acordos ou negociações realizadas entre os usuários da plataforma.</p>
          </section>

          <!-- Section 10 -->
          <section id="atualizacoes" class="privacy-section">
            <h2>10. Atualizações deste Termo</h2>
            <p>Este termo poderá ser atualizado periodicamente para refletir alterações legais ou operacionais. O usuário será notificado em caso de mudanças relevantes.</p>
          </section>
        </div>
      </mat-dialog-content>

      <mat-dialog-actions align="end">
        <button mat-button (click)="close()">Fechar</button>
      </mat-dialog-actions>
    </div>
  `,
    styles: [`
    .dialog-container {
      max-width: 900px;
      background-color: #fff;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
    }

    .dialog-content {
      max-height: none !important;
      overflow-y: auto;
      padding: 0 !important;
      flex: 1;
      /* Previne scroll negativo */
      overscroll-behavior: contain;
      scroll-padding-top: 0;
      /* Garante que o scroll inclui todos os elementos */
      position: relative;
    }

    .privacy-header {
      border-bottom: 2px solid #e0e0e0;
      margin-bottom: 1.5rem;
      padding: 1rem 1.5rem 1rem;
      flex-shrink: 0;
      /* Garante que não há margem negativa */
      margin-top: 0;
      /* Força o elemento a ser incluído no fluxo normal */
      position: static;
      display: block;
    }

    .header-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      gap: 1rem;
    }

    .logo {
      max-width: 120px;
      height: auto;
    }

    .version-info {
      text-align: right;
    }

    .version {
      font-weight: 600;
      color: #1976d2;
      margin-bottom: 0.25rem;
      font-size: 0.9rem;
    }

    .publish-date {
      color: #666;
      font-size: 0.8rem;
      margin: 0;
    }

    .company-info {
      background: #f8f9fa;
      border: 1px solid #e9ecef;
      border-radius: 8px;
      padding: 1.5rem;
      margin: 0 1.5rem 1.5rem;
      flex-shrink: 0;
      /* Elimina qualquer margem negativa */
      margin-top: 0;
      /* Garante posicionamento correto */
      position: static;
    }

    .company-title {
      font-size: 1.2rem;
      font-weight: 600;
      color: #1976d2;
      margin-bottom: 1rem;
      text-align: center;
    }

    .company-data p {
      margin-bottom: 0.5rem;
      line-height: 1.5;
    }

    .company-data strong {
      color: #1976d2;
      font-weight: 600;
    }

    .email-link {
      color: #1976d2;
      text-decoration: none;
      font-weight: 500;
    }

    .email-link:hover {
      text-decoration: underline;
    }

    /* Table of Contents Styles */
    .toc {
      background: #f8f9fa;
      border: 1px solid #e9ecef;
      border-radius: 8px;
      padding: 1.5rem;
      margin: 0 1.5rem 1.5rem;
      flex-shrink: 0;
      /* Garante posicionamento correto */
      position: static;
      margin-top: 0;
    }

    .toc-title {
      font-size: 1.2rem;
      font-weight: 600;
      color: #1976d2;
      margin-bottom: 1rem;
    }

    .toc-list {
      list-style: decimal;
      padding-left: 1.2rem;
    }

    .toc-list li {
      margin-bottom: 0.5rem;
    }

    .toc-list a {
      color: #1976d2;
      text-decoration: none;
      display: block;
      padding: 0.25rem 0;
      border-radius: 4px;
      transition: all 0.2s ease;
      cursor: pointer;
    }

    .toc-list a:hover, 
    .toc-list a:focus {
      background: #e3f2fd;
      text-decoration: underline;
      outline: 2px solid #1976d2;
      outline-offset: 2px;
    }

    .privacy-content {
      padding: 0 1.5rem 1rem;
    }

    .title-section {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 1.5rem;
      flex-wrap: wrap;
      gap: 1rem;
    }

    .main-title {
      font-size: 1.5rem;
      font-weight: 700;
      color: #1976d2;
      margin: 0;
    }

    .download-section {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }

    .download-btn {
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
    }

    .privacy-section {
      margin-bottom: 1.5rem;
      scroll-margin-top: 100px;
    }

    .privacy-section h2 {
      font-size: 1.1rem;
      font-weight: 600;
      color: #1976d2;
      margin-bottom: 0.75rem;
      border-bottom: 1px solid #e3f2fd;
      padding-bottom: 0.25rem;
    }

    .privacy-section h3 {
      font-size: 1rem;
      font-weight: 600;
      color: #1976d2;
      margin-bottom: 0.5rem;
    }

    .privacy-section p {
      margin-bottom: 0.75rem;
      line-height: 1.5;
      text-align: justify;
    }

    .privacy-section ul {
      margin-bottom: 0.75rem;
      padding-left: 1.25rem;
    }

    .privacy-section li {
      margin-bottom: 0.5rem;
      line-height: 1.5;
      text-align: justify;
    }

    .data-category {
      background: #f8f9fa;
      border: 1px solid #e9ecef;
      border-radius: 6px;
      padding: 1rem;
      margin-bottom: 1rem;
    }

    .data-category h3 {
      color: #1976d2;
      font-size: 1rem;
      margin-top: 0;
      margin-bottom: 0.5rem;
    }

    .data-category p {
      margin-bottom: 0;
      color: #555;
    }

    .contact-info {
      background: #e8f5e8;
      border: 1px solid #c8e6c9;
      border-radius: 6px;
      padding: 1rem;
      margin-top: 1rem;
    }

    .contact-info p {
      margin-bottom: 0.5rem;
    }

    .contact-info p:last-child {
      margin-bottom: 0;
    }

    @media (max-width: 768px) {
      .header-content {
        flex-direction: column;
        text-align: center;
      }

      .version-info {
        text-align: center;
      }

      .title-section {
        flex-direction: column;
        align-items: stretch;
      }

      .main-title {
        font-size: 1.25rem;
        text-align: center;
      }

      .privacy-content {
        padding: 0 1rem 1rem;
      }

      .company-info {
        margin: 0 1rem 1.5rem;
        padding: 1rem;
      }

      .company-title {
        font-size: 1.1rem;
      }

      .toc {
        margin: 0 1rem 1.5rem;
        padding: 1rem;
      }

      .toc-title {
        font-size: 1.1rem;
      }

      .privacy-header {
        padding: 1rem;
      }
    }
  `]
})
export class DialogPrivacyPolicyComponent implements AfterViewInit {
    constructor(
        public dialogRef: MatDialogRef<DialogPrivacyPolicyComponent>
    ) { }

    close(): void {
        this.dialogRef.close();
    }

    scrollToSection(sectionId: string, event: Event): void {
        event.preventDefault();
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    downloadPDF(): void {
        // Download direto do PDF já gerado
        const link = document.createElement('a');
        link.href = '/assets/docs/politica-privacidade.pdf';
        link.download = 'hubmedical-politica-de-privacidade.pdf';
        link.click();
    }

    ngAfterViewInit(): void {
        // Aguarda o diálogo ser completamente renderizado
        setTimeout(() => {
            this.forceScrollToAbsoluteZero();
        }, 0);
    }

    private forceScrollToAbsoluteZero(): void {
        const dialogContent = document.querySelector('.dialog-content') as HTMLElement;
        if (!dialogContent) return;

        // Método 1: Reset imediato múltiplo
        for (let i = 0; i < 5; i++) {
            dialogContent.scrollTop = 0;
            dialogContent.scrollLeft = 0;
        }

        // Método 2: Usar scrollTo com options
        dialogContent.scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant'
        });

        // Método 3: Forçar com requestAnimationFrame
        requestAnimationFrame(() => {
            dialogContent.scrollTop = 0;
            
            // Método 4: Timeout adicional
            setTimeout(() => {
                dialogContent.scrollTop = 0;
                
                // Método 5: Se ainda não zerou, usar scrollIntoView no primeiro elemento
                if (dialogContent.scrollTop > 0) {
                    const firstElement = dialogContent.querySelector('.privacy-header') as HTMLElement;
                    if (firstElement) {
                        firstElement.scrollIntoView({ 
                            block: 'start', 
                            inline: 'start',
                            behavior: 'instant'
                        });
                    }
                }

                // Verificação final
                setTimeout(() => {
                    const finalScrollTop = dialogContent.scrollTop;
                    const maxScrollTop = dialogContent.scrollHeight - dialogContent.clientHeight;

                    // Se ainda falhou, aplicar correção CSS drástica
                    if (finalScrollTop > 0) {
                        this.applyCSSFix(dialogContent);
                    } else {
                        // Adicionar listener só se conseguiu zerar
                        this.addScrollListener(dialogContent);
                    }
                }, 100);
            }, 50);
        });
    }

    private applyCSSFix(element: HTMLElement): void {
        // Forçar reset via CSS
        element.style.paddingTop = '0px';
        element.style.marginTop = '0px';
        element.style.scrollPaddingTop = '0px';
        
        // Forçar o primeiro filho também
        const firstChild = element.firstElementChild as HTMLElement;
        if (firstChild) {
            firstChild.style.marginTop = '0px';
            firstChild.style.paddingTop = '0px';
            firstChild.style.transform = 'translateY(0px)';
        }
        
        // Reset final após CSS
        setTimeout(() => {
            element.scrollTop = 0;
            this.addScrollListener(element);
        }, 50);
    }

    private addScrollListener(element: Element): void {
        let isLogging = false;
        
        element.addEventListener('scroll', () => {
            if (!isLogging) {
                isLogging = true;
                setTimeout(() => {
                    isLogging = false;
                }, 100);
            }
        });
    }
}